import { Multiplication } from './mathMultiplication';
import { Common, SimpleGenEq } from '../genHelper';

export class Math_Division__2 extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.simple([2], 1)), 'Math_Division__2');
  }
}
export class Math_Division__3 extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.simple([3], 1)), 'Math_Division__3');
  }
}
export class Math_Division__4 extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.simple([4], 1)), 'Math_Division__4');
  }
}
export class Math_Division__5 extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.simple([5], 1)), 'Math_Division__5');
  }
}
export class Math_Division__6 extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.simple([6], 1)), 'Math_Division__6');
  }
}
export class Math_Division__7 extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.simple([7], 1)), 'Math_Division__7');
  }
}
export class Math_Division__8 extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.simple([8], 1)), 'Math_Division__8');
  }
}
export class Math_Division__9 extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.simple([9], 1)), 'Math_Division__9');
  }
}
export class Math_Division__10 extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.simple([10], 1)), 'Math_Division__10');
  }
}
export class Math_Division__11 extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.simple([11], 1)), 'Math_Division__11');
  }
}
export class Math_Division__12 extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.simple([12], 1)), 'Math_Division__12');
  }
}
export class Math_Division__13 extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.simple([13], 1)), 'Math_Division__13');
  }
}
export class Math_Division__14 extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.simple([14], 1)), 'Math_Division__14');
  }
}
export class Math_Division__15 extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.simple([15], 1)), 'Math_Division__15');
  }
}

// TimesTables
export class Math_Division_TimesTables__All extends SimpleGenEq {
  constructor() {
    super(
      Common.divide(Multiplication.simple([1, 2, 3, 4, 5, 6, 7, 8, 9, 10], 1)),
      'Math_Division_TimesTables__All'
    );
  }
}
export class Math_Division_TimesTables__Harder extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.advanced()), 'Math_Division_TimesTables__Harder');
  }
}

// Digits
export class Math_Division_Digits__XXXXXXX__Y extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.divDigits(7, 1)), 'Math_Division_Digits__XXXXXXX__Y');
  }
}
export class Math_Division_Digits__XXXXXXX__YY extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.divDigits(7, 2)), 'Math_Division_Digits__XXXXXXX__YY');
  }
}
export class Math_Division_Digits__XXXXXXX__YYY extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.divDigits(7, 3)), 'Math_Division_Digits__XXXXXXX__YYY');
  }
}
export class Math_Division_Digits__XXXXXXX__YYYY extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.divDigits(7, 4)), 'Math_Division_Digits__XXXXXXX__YYYY');
  }
}
export class Math_Division_Digits__XXXXXXX__YYYYY extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.divDigits(7, 5)), 'Math_Division_Digits__XXXXXXX__YYYYY');
  }
}
export class Math_Division_Digits__XXXXXXX__YYYYYY extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.divDigits(7, 6)), 'Math_Division_Digits__XXXXXXX__YYYYYY');
  }
}
export class Math_Division_Digits__XXXXXX__Y extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.divDigits(6, 1)), 'Math_Division_Digits__XXXXXX__Y');
  }
}
export class Math_Division_Digits__XXXXXX__YY extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.divDigits(6, 2)), 'Math_Division_Digits__XXXXXX__YY');
  }
}
export class Math_Division_Digits__XXXXXX__YYY extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.divDigits(6, 3)), 'Math_Division_Digits__XXXXXX__YYY');
  }
}
export class Math_Division_Digits__XXXXXX__YYYY extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.divDigits(6, 4)), 'Math_Division_Digits__XXXXXX__YYYY');
  }
}
export class Math_Division_Digits__XXXXXX__YYYYY extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.divDigits(6, 5)), 'Math_Division_Digits__XXXXXX__YYYYY');
  }
}
export class Math_Division_Digits__XXXXX__Y extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.divDigits(5, 1)), 'Math_Division_Digits__XXXXX__Y');
  }
}
export class Math_Division_Digits__XXXXX__YY extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.divDigits(5, 2)), 'Math_Division_Digits__XXXXX__YY');
  }
}
export class Math_Division_Digits__XXXXX__YYY extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.divDigits(5, 3)), 'Math_Division_Digits__XXXXX__YYY');
  }
}
export class Math_Division_Digits__XXXXX__YYYY extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.divDigits(5, 4)), 'Math_Division_Digits__XXXXX__YYYY');
  }
}
export class Math_Division_Digits__XXXX__Y extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.divDigits(4, 1)), 'Math_Division_Digits__XXXX__Y');
  }
}
export class Math_Division_Digits__XXXX__YY extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.divDigits(4, 2)), 'Math_Division_Digits__XXXX__YY');
  }
}
export class Math_Division_Digits__XXXX__YYY extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.divDigits(4, 3)), 'Math_Division_Digits__XXXX__YYY');
  }
}
export class Math_Division_Digits__XXX__Y extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.divDigits(3, 1)), 'Math_Division_Digits__XXX__Y');
  }
}
export class Math_Division_Digits__XXX__YY extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.divDigits(3, 2)), 'Math_Division_Digits__XXX__YY');
  }
}
export class Math_Division_Digits__XX__Y extends SimpleGenEq {
  constructor() {
    super(Common.divide(Multiplication.divDigits(2, 1)), 'Math_Division_Digits__XX__Y');
  }
}
